import * as React from 'react';
import FormDatePicker from './form/DatePicker';
import FormSelectLabeled from './form/SelectLabeled';
import { getAvailableTimeSlots, Event } from '../../api/Property';
import * as moment from 'moment';
import { momentDateFormat } from '../../utilities/formatting';
import { getTodaysDateString } from '../../utilities/Utils';
import LoadingOverlay from './LoadingOverlay';
import { useEffect, useState } from 'react';

export interface Props {
    event?: Event;
    date?: string;
    propertyId: number;
    onDateChanged: (newDate: string) => void;
    onTimeslotChanged: (newTimeslot: Event | undefined) => void;
}
export interface State {
    availableTimeSlots: Event[];
    isLoading: boolean;
    errorMessage?: string;
}

const formatDate = (date?: string) => date && moment(date).format(momentDateFormat);

const TourTimeSlotInput = (props: Props) => {
    const [availableTimeSlots, setAvailableTimeSlots] = useState<Event[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const getTimeSlots = async (selectedDate: string) => {
        setAvailableTimeSlots([]);
        setIsLoading(true);

        let result = await getAvailableTimeSlots(props.propertyId, formatDate(selectedDate)!);
        if (result.success && result.data) {
            setAvailableTimeSlots(result.data);
            setErrorMessage(undefined);

            let targetIndex = 0;
            if (props.event) {
                for (let i = 0; i < result.data.length; i++) {
                    if (result.data[i].startDateTime === props.event.startDateTime) {
                        targetIndex = i;
                        break;
                    }
                }
            }
            props.onTimeslotChanged(result.data[targetIndex]);
            setIsLoading(false);
        } else {
            setIsLoading(false);
            setErrorMessage(result.error);
        }
    };

    useEffect(() => {
        getTimeSlots(props.date || getTodaysDateString());
    }, [props.date]);

    return (
        <div className="col-sm-12">
            <LoadingOverlay show={isLoading} inBootstrapColumn={true} />
            <div>
                <FormDatePicker
                    inputProps={{
                        id: 'requested-date',
                        name: 'date',
                        value: formatDate(props.date) || getTodaysDateString(),
                        required: true
                    }}
                    labelProps={{
                        labelText: 'Requested Date',
                        invalidText: 'Please select a valid date'
                    }}
                    onChange={(_, newValue) => props.onDateChanged(newValue)}
                />
                <FormSelectLabeled
                    selectProps={{
                        id: 'requested-time',
                        name: 'timeslot',
                        placeholder:
                            availableTimeSlots.length > 0
                                ? 'Select a time slot'
                                : 'No times available',
                        value: (props.event && availableTimeSlots.indexOf(props.event)) || 0,
                        required: true
                    }}
                    selectOptions={availableTimeSlots.map((timeslot, index) => ({
                        value: index,
                        label: timeslot.isTourNow? `Tour Now ( Ends at - ${moment(
                            timeslot.endDateTime
                        ).format('h:mm A')} )`: `${moment(timeslot.startDateTime).format('h:mm A')} - ${moment(
                            timeslot.endDateTime
                        ).format('h:mm A')}`
                    }))}
                    labelProps={{
                        labelText: 'Time',
                        invalidText: 'Please select a time slot'
                    }}
                    onChange={(_, newValue) =>
                        props.onTimeslotChanged(availableTimeSlots[newValue as number])
                    }
                />
            </div>
            {errorMessage && <p className="text-danger">{errorMessage}</p>}
        </div>
    );
};

export default TourTimeSlotInput;



// WEBPACK FOOTER //
// ./src/components/common/TourTimeSlotInput.tsx